/**
 * PGSS-5442. What build am I looking at?
 *
 * Until this existed there was no way to answer that — the version had never moved off 1.0.0 and
 * nothing displayed it. When someone reports a problem the first question is which build they are
 * on, and neither they nor we could say. A fix could ship and nobody could confirm from the screen
 * whether the person still seeing it had actually received the fix.
 *
 * Values are stamped at BUILD time by vite.config.mjs, not read at run time — importing
 * package.json into application code would ship the whole dependency manifest to the browser.
 *
 * Named versionInfo rather than appVersion because the component beside it is AppVersion, and on a
 * case-insensitive filesystem those two are the same file. That is not hypothetical: writing both
 * silently left one file importing itself.
 */

/** Empty rather than a guess: a wrong version is worse than none, because it gets trusted. */
export const APP_VERSION = process.env.REACT_APP_VERSION || '';
export const APP_COMMIT = process.env.REACT_APP_COMMIT || '';
export const APP_BUILT_AT = process.env.REACT_APP_BUILT_AT || '';

/** "v3.0.2" — what a user reads out. Empty when unstamped, so callers render nothing. */
export const versionLabel = () => (APP_VERSION ? `v${APP_VERSION}` : '');

/**
 * "v3.0.2 · a1b2c3d · 1 Sep 2026" — the support string, shown on hover.
 *
 * The commit matters because two builds can carry the same version while a fix is in flight, and
 * the version alone cannot tell them apart.
 */
export const versionDetail = () => {
  const parts = [versionLabel(), APP_COMMIT].filter(Boolean);
  if (APP_BUILT_AT) {
    const built = new Date(APP_BUILT_AT);
    // An unparseable stamp is skipped rather than rendered as "Invalid Date".
    if (!Number.isNaN(built.getTime())) {
      parts.push(built.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }));
    }
  }
  return parts.join(' · ');
};
